import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Container, Css } from '@pdrj/pmi-iqos-ds-react'

const RollingNumber = ({ value, isSizeXL }) => {
  const digits = value?.toString().split('')
  return (
    <Container
      display={Container.displays.flex}
      alignItems={Container.alignItemsValues.center}
      additionalClasses={`q-text-white ${
        isSizeXL
          ? 'xxl:q-text-7xl md:q-text-6xl q-text-3xl q-leading-under-snug'
          : ''
      }`}>
      {digits?.map((digit, index) => (
        <Css
          key={index}
          s={{
            overflow: 'hidden',
            height: '1.4em',
            display: 'inline-block',
            position: 'relative',
            width: '0.6em',
            textAlign: 'center'
          }}>
          <AnimatePresence mode="popLayout">
            <motion.span
              key={digit}
              style={{ display: 'block' }}
              initial={{ y: '100%', opacity: 0, filter: 'blur(4px)' }}
              animate={{ y: '0%', opacity: 1, filter: 'blur(0px)' }}
              exit={{ y: '-100%', opacity: 0, filter: 'blur(4px)' }}
              transition={{ duration: 0.25, ease: 'easeOut' }}>
              {digit}
            </motion.span>
          </AnimatePresence>
          {/* </div> */}
        </Css>
      ))}
    </Container>
  )
}

const Countdown = ({ from, to = 0, ms = 80, isSizeXL = false }) => {
  const [value, setValue] = useState(from ?? to)

  useEffect(() => {
    if (value < to) {
      setValue(to)
      return () => {}
    }
    if (value === to) return () => {}
    const id = setTimeout(() => setValue(v => v - 1), ms)
    return () => clearTimeout(id)
  }, [value, to, ms])

  return <RollingNumber value={value} isSizeXL={isSizeXL} />
}
export default Countdown
